module.exports = __webpack_public_path__ + "img/dcc.072c94f8.png";